
import { MdOutlineNotifications,MdOutlineNotificationsActive } from "react-icons/md";
import "./ProviderNotifications.scss";
import { Dropdown } from "antd";
import { useEffect, useRef, useState } from "react";
import approvalIcon from "../../Assets/img/icons/AP.png";
import claimIcon from "../../Assets/img/icons/CL.png";
import { deleteNotifications } from "../../Services/deleteNotifications";

function ProviderNotifications({ notifications, notificationCounter, setNotificationCounter }) {
    const handleOpenChange = (open) => {
        if (!open) {
            deleteNotifications();
        }
        if(notificationCounter) setNotificationCounter(0);
      };
    const items = notifications.length === 0 ? [
            {
            key: 0,
            label: (
                <div className="notification-container" style={{justifyContent:"center"}}>
                   <h6 style={{color:"#1cc9bc"}}>لا يوجد اشعارات</h6>
                </div>
            ),
            }
        ]
        : notifications.map((notification, index) => {
        if (notification.messageContentType === "json"){
            if (notification.messageContent.startsWith("'") && notification.messageContent.endsWith("'")) {
                notification.messageContent = notification.messageContent.slice(1, -1);
            }
            let messageContent = JSON.parse(notification.messageContent)
            notification.title = messageContent.title
            notification.description = messageContent.description
            notification.type = messageContent.type
            notification.createdAt = new Date(notification.createdAt).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
        }

        return ({
            key: index,
            label: (
                <div className="notification-container">
                    <div style={{width: "10%"}}>
                        <img src={notification.type == "approval" ? approvalIcon : claimIcon} alt="icon" style={{width: "100%"}}/>
                    </div>
                    <div key={index} className="notification-item">
                    <div className="notification-header">
                        <h6 className="notification-title">{notification.title}</h6>
                        <p className="notification-date">{notification.createdAt}</p>
                    </div>
                    <p className="notification-desc">{notification.description}</p>
                    </div>
                </div>
              ),
        });
    });
    
    const dropdownRender = (menu) => (
        <div
          style={{
            maxHeight: "40vh",
            overflowY: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: "#1cc9bc",
            scrollBehavior: "smooth",
            boxShadow: "4px 4px 7px 0px rgba(0, 0, 0, 0.2)",
            borderRadius: "0 0 10px 10px",
            direction: "rtl",
            width:"18vw",
            maxWidth:"22vw",
            borderBottom:"3px solid #1cc9bc",

          }}
        >
          {menu}
        </div>
      );

      

    return (
        
        <div style={{cursor:"pointer"}}>

        <Dropdown
            menu={{
                items:items,
            }}
            trigger={['click']}
            placement="bottomRight"
            arrow
            dropdownRender={dropdownRender}
            onOpenChange={handleOpenChange}
        >

            {
                notificationCounter ? 
                    <div className="notification-icon">
                        <MdOutlineNotificationsActive size={24}/>
                        <span className="notification-count animate">{notificationCounter}</span>
                    </div>
                    : <MdOutlineNotifications size={24}/>
            }

        </Dropdown>
    </div>
  )
}

export default ProviderNotifications
